import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toggle-icon-input',
  templateUrl: './toggle-icon-input.component.html',
  styleUrls: ['./toggle-icon-input.component.scss']
})
export class ToggleIconInputComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
